import React from 'react';
import { useParams } from 'react-router-dom';

import { QuestionnaireContextProvider } from '../../context/questionnaire';
import QuestionnaireSliderComponent from '../../components/questionnaire/slider';
import { QuestionnaireType } from '../../entities/questionnaire-type';

export default function QuestionnaireScreenerAsitPageComponent() {
  const { step } = useParams();

  const intProductId = 11;

  return (
    <QuestionnaireContextProvider
      type={step === '2' ? QuestionnaireType.Full : QuestionnaireType.Onboarding}
      productId={intProductId}
    >
      <QuestionnaireSliderComponent productId={intProductId} />
    </QuestionnaireContextProvider>
  );
}
